import { Box } from "~/components/ui/box";

type MenuSectionProps = {
  children: React.ReactNode;
};

export const MenuSection = (props: MenuSectionProps) => {
  return <Box {...props} padding="small" />;
};
